
import React, { useEffect, useState, Component } from "react";
import { applyDataTable } from '../../../custom/dataTable';
import ListItem from '@material-ui/core/ListItem';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Multiselect from "multiselect-react-dropdown"
import Vector from '@material-ui/icons/Close';
import downloadIcon from '../../../../Assets/img/svg/DownloadIcon.svg';
import shareIcon from '../../../../Assets/img/svg/ShareIcon.svg';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import {warningAlert} from "../../../custom/alert"
import $ from 'jquery';
import del from "../../../../Assets/img/svg/Del.svg"
import moment from "moment";
import Divider from '@material-ui/core/Divider';
import { useNavigate } from "react-router-dom"
import {
    TextField, FormControlLabel, Radio, Checkbox,
    Select, MenuItem, InputBase, Chip, Input, Button, InputAdornment,
    IconButton, FormHelperText, FormControl, RadioGroup
} from '@material-ui/core';
import PropTypes from 'prop-types';
import styles from "../../../../Assets/jss/customStyle";
import { withStyles } from '@material-ui/core/styles';
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import axios from "axios";
import API from "../../../../helpers/endpointService"
import { Buffer } from 'buffer';
// import { Grid } from "ag-grid-community";
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { inspectionSystem, inspectionType, shipType } from "../../../Constants";
import ShipLogo from "../../../../Assets/img/svg/ShipLogosvg.svg";
import PdfIcon from "../../../../Assets/img/svg/PdfIcon.svg";
import DocumentIcon from "../../../../Assets/img/svg/DocumentIcon.svg";
import chevronsright from "../../../../Assets/img/svg/chevronsright.svg";
import { htmlDecode, htmlEncode } from "../EncodeDecode.js"
import { errorToast } from "../../../../actions/CommonFunction";

const useStyles = makeStyles((theme) => ({
    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
        padding: "5px 10px"
    },
    fontIcon: {
        paddingRight: "8px",
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },
    error: {
        color: '#f44336',
    },
    helperText: {
        '& p': {
            marginLeft: "0px !important"
        }
    },
}));
const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);


const names = [
    'Oliver Hansen',
    'Van Henry',
    'April Tucker',
    'Ralph Hubbard',
];

function getStyles(name, personName, theme) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}
const BootstrapError = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #f44336',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);
class Overview extends Component {
    constructor(props) {
        super(props);
        this.multiselectRef = React.createRef();
        this.state = {
            isMobile: false,
            isError: false,
            ShipId: 0,
            InspectionId: 0,
            TotalGrade: 0,
            ShipName: "",
            ShipLogo: "",
            IMONumber: "",
            ShipType: 0,
            ManagementAS: "",
            Breadth: "",
            PreviousName: "",
            TechnicalManager: "",
            Depth: "",
            ShipBuilder: "",
            Summer: "",
            PortofRegistry: "",
            DeliveryDate: "",
            CallSign: "",
            DeadWeight: "",
            Mmsi: "",
            Flag: "",
            GrossTonnage: "",
            Teu: "",
            Class: "",
            NetTonnage: "",
            LightWeight: "",
            RegisteredOwner: "",
            LengthOverall: "",
            InspectionLocation: "",
            InspectionType: 0,
            InspectionLocation: "",
            InspectionSummary: "",
            values: [],
            Status: "",
            GradingData: [],
            GradingData1: [],
            dataList: [],
            CompletionDate: "",
            addData: {
                "Id": 0,
                "UniqueId": ""
            },
            ciiCompliance:{
                "EEXI": "",
                "EEDI": "",
                "AER": "",
                "CIIBand": ""
              }
            
        }
    }
    componentDidMount() {
        this.state.ShipId = parseInt(localStorage.getItem("DashId"));
        this.state.ShipName = localStorage.getItem("ShipName");
        this.state.addData.Id = parseInt(localStorage.getItem("DashId"));
        this.state.InspectionId = parseInt(localStorage.getItem("InspectionId"));
        this.setState({})
        if (parseInt(localStorage.getItem("DashId")) != null) {
            this.getShipSummaryInfo(this.state.ShipId, this.state.InspectionId);
            this.getCiiComplance( this.state.InspectionId, inspectionSystem.DecarbanizationSummary)
            this.getshipinfo(localStorage.getItem("DashId"))
            this.getshipbasicinfo(localStorage.getItem("DashId"))
            this.getShortSummaryDesc(this.state.ShipId, this.state.InspectionId);
            this.GetGradingdata(inspectionSystem.GradingData);
            this.dataTable();
        }
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }
    getCiiComplance=(InspectionId,SectionId)=>{
        let apiUrl = `${API.Get_CIICOMPLIANCE}?sectionId=${SectionId}&inspectionId=${InspectionId}`;
        
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                   this.state.ciiCompliance=response.data;                 
                   this.setState({})
                }
            })
    }

    dataTable = () => {
        let apiUrl = `${API.Get_Notable}?ShipId=${this.state.ShipId}&InspectionId=${this.state.InspectionId}&SectionId=${inspectionSystem.keyNotableItems}`;
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.state.dataList = [];
                    this.setState({})
                    if (response?.data.length !== 0) {
                        this.state.dataList = response?.data;
                        response.data.sort((a, b) => {
                            return a.Id - b.Id;
                        });
                    }
                    this.setState({})
                } else {
                }
            })
            .catch((error) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {

                }
            });
    };

    GetGradingdata = (Id) => {
        const { dispatch } = this.props;
        let Ship = parseInt(localStorage.getItem("DashId"));
        let inspection = parseInt(localStorage.getItem("InspectionId"));
        let apiUrl = `${API.Get_Grading}?ShipId=${Ship}&InspectionId=${inspection}&SectionId=${Id}`;
        this.props.dispatch({ type: "SHOW_LOADER", data: true });
        axios.get(apiUrl)
            .then((response) => {
                if (response?.status === 200) {
                    this.state.GradingData.push({ "Id": 1, "title": "Design & Construction", "value": response.data?.Condition?.DesignAndConstruction });
                    this.state.GradingData.push({ "Id": 2, "title": "Hull", "value": response.data?.Condition?.Hull });
                    this.state.GradingData.push({ "Id": 3, "title": "Foc'sle & Poop Deck", "value": response.data?.Condition?.FocsleAndPoopDeck });
                    this.state.GradingData.push({ "Id": 4, "title": "Maindeck & Fittings", "value": response.data?.Condition?.MaindeckAndFittings });
                    this.state.GradingData.push({ "Id": 5, "title": "Ballast Tanks & Void Spaces", "value": response.data?.Condition?.BallastTanksAndVoidSpaces });
                    this.state.GradingData.push({ "Id": 6, "title": "Galley & Accomodation", "value": response.data?.Condition?.GalleyAndAccomodation });
                    this.state.GradingData.push({ "Id": 7, "title": "Engine Room, Machinery & Machinery Spaces", "value": response.data?.Condition?.EngineRoom });
                    this.state.GradingData.push({ "Id": 8, "title": "Fire Fighting Appliances", "value": response.data?.Condition?.FireAndSafety });
                    this.state.GradingData.push({ "Id": 9, "title": "Lifesaving Equipment", "value": response.data?.Condition?.LifesavingEquipment });
                    this.state.GradingData.push({ "Id": 10, "title": "Safe Working", "value": response.data?.Condition?.SafeWorking });
                    this.state.GradingData.push({ "Id": 11, "title": "Navigation Bridge & Communication", "value": response.data?.Condition?.NavigationBridgeAndCommunication });
                    this.state.GradingData.push({ "Id": 12, "title": "Pollution Control", "value": response.data?.Condition?.PollutionControl });
                    this.state.GradingData.push({ "Id": 13, "title": "Onboard Management and Crew Motivation", "value": response.data?.Condition?.OnboardManagement });
                    this.state.GradingData.push({ "Id": 14, "title": "Cargo Systems", "value": response.data?.Condition?.CargoSystems });

                    this.state.GradingData1.push({ "Id": 1, "title": "Forthcoming Regulatory Compliance", "value": response.data?.Management?.ForthcomingRegulatoryCompliance });
                    this.state.GradingData1.push({ "Id": 2, "title": "Crew Welfare", "value": response.data?.Management?.CrewWelfare });
                    this.state.GradingData1.push({ "Id": 3, "title": "Crew Performance", "value": response.data?.Management?.CrewPerformance });
                    this.state.GradingData1.push({ "Id": 4, "title": "HSEQ Systems", "value": response.data?.Management?.HseqSystems });
                    this.state.GradingData1.push({ "Id": 5, "title": "Management Systems (ISM / PMS)", "value": response.data?.Management?.ManagementSystems });
                    this.state.GradingData1.push({ "Id": 6, "title": "Classification & Certification", "value": response.data?.Management?.ClassificationAndCertification });
                    this.state.GradingData1.push({ "Id": 7, "title": "Vetting / PSC Performance / Records", "value": response.data?.Management?.VettingOrPscperformanceOrRecords });

                    this.setState({});
                    dispatch({ type: "SHOW_LOADER", data: false })
                } else {

                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false });
                 // warningAlert("Something went wrong. Please try again.");
                 errorToast();
                 this.props.dispatch({ type: "CANCEL", data: true });
                if (error?.response?.status === 401) {
                    
                }
            });
    }


    getShipSummaryInfo = (id, inspection) => {
        const { dispatch } = this.props;
        let apiUrl = `${API.Get_Inspection}?ShipId=${id}&InspectionId=${inspection}&SectionId=${inspectionSystem.InspectionSummary}`;
        dispatch({ type: "SHOW_LOADER", data: true })
        axios.get(apiUrl)
            .then((response) => {
                if (response?.status === 200) {
                    if (response?.data.Id !== 0) {
                        this.state.TotalGrade = response?.data?.TotalGrade;
                        this.setState({})
                    }
                    dispatch({ type: "SHOW_LOADER", data: false })
                } else {

                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) { }
            });
    };

    getShortSummaryDesc = (id, inspection) => {
        const { dispatch } = this.props;
        let apiUrl = `${API.Get_Richtext}?ShipId=${id}&InspectionId=${inspection}&SectionId=${inspectionSystem.SummaryShort}`;
        dispatch({ type: "SHOW_LOADER", data: true })
        axios.get(apiUrl)
            .then((response) => {
                if (response?.status === 200) {
                    if (response?.data.Description !== null && response?.data.Id !== 0) {
                        let result = htmlDecode(response?.data?.Description);
                        this.state.InspectionSummary = result;
                        this.setState({})
                        var div = $('<div />');
                        div.append(this.state.InspectionSummary);
                        div.find('*').each(function () {
                            $(this).css('font-size', '14px');
                            $(this).css('font-family', "Open Sans, sans-serif");
                        });
                        setTimeout(function () {
                           document.getElementById("overview-font").innerHTML= div.html();
                        }, 10);

                    }
                    dispatch({ type: "SHOW_LOADER", data: false })
                } else {

                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) { }
            });
    }

    getshipbasicinfo = (data) => {
        let apiUrl = API.GET_SHIP + "/id?id=" + data;
        axios({
            method: "get",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.Status = response.data?.Status;
                    this.state.IMONumber = response.data?.IMONumber;
                    this.state.InspectionType = response.data?.InspectionType;
                    this.state.CompletionDate = response?.data?.CompletionDate;
                    this.state.addData.UniqueId = response?.data?.PDFKey;
                    localStorage.setItem("IsGradeApplicable", response.data?.IsGradeApplicable != null ? response.data?.IsGradeApplicable : false);
                    window.dispatchEvent(new Event("isGradeApplicableChanged"));
                    if (response?.data?.ShipPhoto != null && response?.data?.ShipPhoto != "") {
                        this.state.ShipLogo = response?.data?.ShipPhoto?.FileUrl;
                    }
                    this.setState({},()=>{
                        console.log("inspection",this.state.InspectionType)
                    })
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false });
                warningAlert("Something went wrong. Please try again.");
                if (error?.response?.status === 401) {
                }
            });

    };

    getshipinfo = (data) => {
        const { dispatch } = this.props;
        let Inspection = parseInt(localStorage.getItem("InspectionId"))
        let Id = parseInt(data)
        let apiUrl = `${API.Get_Vessel}?ShipId=${Id}&InspectionId=${Inspection}&SectionId=${inspectionSystem.Vesselparticulars}`;
        this.props.dispatch({ type: "SHOW_LOADER", data: true });
        axios.get(apiUrl)
            .then((response) => {
                if (response?.status === 200) {
                    if (response?.data.Id !== 0) {
                        this.state.ShipType = parseInt(response?.data.ShipType);
                        this.state.InspectionLocation = response?.data?.InspectionLocation;
                        this.state.ManagementAS = response?.data?.ManagementAS;
                        this.state.Breadth = response?.data?.Breath;
                        this.state.PreviousName = response?.data?.PreviousName;
                        this.state.TechnicalManager = response?.data?.TechnicalManager;
                        this.state.Depth = response?.data?.Depth;
                        this.state.ShipBuilder = response?.data?.ShipBuilder;
                        this.state.Summer = response?.data?.Summer;
                        this.state.PortOfRegistry = response?.data?.PortOfRegistry;
                        this.state.DeliveryDate = response?.data?.DeliveryDate;
                        this.state.CallSign = response?.data?.CallSign;
                        this.state.DeadWeight = response?.data?.DeadWeight;
                        this.state.Mmsi = response?.data?.Mmsi;
                        this.state.Flag = response?.data?.Flag;
                        this.state.GrossTonnage = response?.data?.GrossTonnage;
                        this.state.NetTonnage = response?.data?.NetTonnage;
                        this.state.Teu = response?.data?.Teu;
                        this.state.Class = response?.data?.Class;
                        this.state.LightWeight = response?.data?.LightWeight;
                        this.state.RegisteredOwner = response?.data?.RegisteredOwner;
                        this.state.LengthOverall = response?.data?.LengthOverall;
                        this.setState({})
                    }
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                }
            });
    };

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#FINAL1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#FinalReport1 .MuiListItemText-primary").addClass("fw-bolder")
        $("#FinalReport").removeClass("d-none")
        $("#FinalReport").addClass("d-block")
        $("#FR .MuiListItemText-primary").addClass("fw-bolder")
        $("#FRL").addClass("active-color")
    };

    DownloadReport = () => {
        if (this.state.addData.Id != 0) {
            this.DownloadFinalReport(this.state.addData)
        }
    }

    DownloadFinalReport = (data) => {
        let apiUrl = API.FINAL_REPORT_DOWN;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
            responseType: "blob",

        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    let fileName = response.headers['content-disposition'].split('filename="')[1].split('";')[0];
                    let blob = new Blob([response.data]);
                    let url = URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = fileName;
                    a.click();
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                warningAlert("Something went wrong. Please try again.");
                if (error?.response?.status === 401) {
                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#FINAL1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#FinalReport1 .MuiListItemText-primary").removeClass("fw-bolder")
        $("#FinalReport").addClass("d-none")
        $("#FinalReport").removeClass("d-block")
        $("#FR .MuiListItemText-primary").removeClass("fw-bolder")
        $("#FRL").removeClass("active-color")
    }

    ViewDocuments = () => {
        this.props.navigate(`/ship/documents`);
    }
    ViewPhotographs = () => {
        this.props.navigate(`/ship/photographs`);
    }

    ViewReport = () => {
        this.props.navigate(`/finalreport`);
    }

    AddCancel1 = () => {
        this.props.navigate(`/shiplist`)
    }

    render() {
        const { isMobile, shiptype, less } = this.state;
        let { classes, menuToggle } = this.props;
        return (
            <>

                {isMobile ?
                    <>
                        <div className="row w-100  mt-4 mob-topfixed">
                            <div className="col-5 w-50 mt-auto">
                                <List className="pt-4 mt-4 " style={{ backgroundColor: "#F6F6F6" }}>
                                    <ListItem>
                                        <ListItemText id={"FINAL" + "1"} className=' textNaviIcon' primary="Overview" />
                                        <NavigateNextIcon id="FINAL" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                        <Divider className='border-bottom' />
                                    </ListItem>
                                </List>
                            </div>
                            <div className="col-7 pt-3 mt-5 w-50">
                                <h4>{this.state.ShipName && this.state.ShipName}</h4>
                            </div>
                        </div>
                    </>
                    :
                    <></>
                }
                <div className="pt-2 ml-auto scroll-hide mt-138" style={{ backgroundColor: "#FFFFFF", width: "100%", marginTop: this.state.isMobile ? -10 : -85 }}>
                    {this.state.isMobile ?
                        <table className="dataTable border-top" width="100%">
                            <tbody>
                                <tr className="">
                                    <td width="5%" className="border-right text-center">
                                        <i
                                            class="fa fa-arrow-left cursorPointer"
                                            onClick={this.AddCancel1}
                                        ></i>
                                    </td>
                                    <td width="95%">
                                    </td>
                                </tr>
                            </tbody>
                        </table> :
                        <>
                            <table className="dataTable" width="100%">
                                <tbody>
                                    <tr className="">
                                        <td width="5%" className="border-right text-center">
                                            <i
                                                class="fa fa-arrow-left cursorPointer"
                                                onClick={this.AddCancel1}
                                            ></i>
                                        </td>
                                        <td width="95%" className=""><>
                                        </>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </>}

                    <div className="row mx-5 mb-3">
                        <div className="col-12 my-4 input-group">
                            <img src={ShipLogo} />
                            <span className="ml-3" style={{ fontSize: '21px', fontWeight: 'bold' }}>{this.state.ShipName && this.state.ShipName}</span>
                        </div>
                        <div className={isMobile ? "col-12" : "col-3 col-sm3"} style={{ backgroundColor: "#F2F8FB" }}>
                            <div style={{ backgroundColor: "#F2F8FB" }}>
                                <div className="p-4 input-group">
                                    {/* {this.state.Status == "Reviewed and Approved" && this.state.addData.UniqueId != "" && this.state.addData.UniqueId != null ? <> */}
                                    <img className="pr-3 cursorPointer" onClick={() => this.DownloadReport()} src={PdfIcon} />
                                    <h4 className="mt-3 cursorPointer" onClick={() => this.DownloadReport()}>Download Report</h4>
                                    {/* </> : <>
                                    <img className="pr-3" src={PdfIcon} />
                                    <h4 className="mt-3" style={{color: "#499AC8"}}>Download Report</h4>
                                    </>} */}
                                </div>
                                <hr className="my-0 mx-4" style={{ border: '1px solid #E3E3E3' }} />
                                <div className="p-4 input-group">
                                    <img className="pr-3 cursorPointer" onClick={() => this.ViewReport()} src={PdfIcon} />
                                    <h4 className="mt-3 cursorPointer" onClick={() => this.ViewReport()}>View Report</h4>
                                </div>
                                <hr className="my-0 mx-4" style={{ border: '1px solid #E3E3E3' }} />
                                <div className="p-4 input-group">
                                    <img className="pr-3 cursorPointer" onClick={() => this.ViewDocuments()} src={DocumentIcon} />
                                    <h4 className="mt-3 cursorPointer" onClick={() => this.ViewDocuments()}>Documents</h4>
                                </div>
                                <hr className="my-0 mx-4" style={{ border: '1px solid #E3E3E3' }} />
                                <div className="p-4 input-group">
                                    <img className="pr-3 cursorPointer" onClick={() => this.ViewPhotographs()} src={DocumentIcon} />
                                    <h4 className="mt-3 cursorPointer" onClick={() => this.ViewPhotographs()}>Photographs</h4>
                                </div>
                            </div>
                            <div className="pb-3" style={{ border: "1px solid #FFFFFF", backgroundColor: "#FFFFFF", marginLeft: -12, marginRight: -12 }}>
                            </div>
                            <div className="mt-3 pb-2" style={{ backgroundColor: "#F2F8FB" }}>
                                <div className="py-4 pl-4">
                                    <span style={{ fontSize: '18px', fontWeight: 'bold' }}>{this.state.ShipName && this.state.ShipName}</span>
                                </div>
                                <div className="pl-4 input-group pb-3">
                                    <img className="pr-2" src={chevronsright} />
                                    <span className="span-design1">IMO : </span>
                                    <span className="pl-2 span-design2">{this.state.IMONumber && this.state.IMONumber}</span>
                                </div>
                                <div className="pl-4 input-group pb-3">
                                    <img className="pr-2" src={chevronsright} />
                                    <span className="span-design1">Status : </span>
                                    <span className="pl-2 span-design2">{this.state.Status && this.state.Status}</span>
                                </div>
                                <div className="pl-4 pb-3 input-group">
                                    <img className="pr-2" src={chevronsright} />
                                    <span className="span-design1 m-overview">Inspection Type : </span>
                                     <span className="span-design2 pl-2">{this.state.InspectionType == inspectionType.PreSale ? "Pre-Sale Inspection Report" : this.state.InspectionType == inspectionType.PrePurchase ? "Pre-Purchase Inspection Report" : this.state.InspectionType == inspectionType.VesselCondition ? "Vessel Condition Report" :this.state.InspectionType == inspectionType.PreDDCondition ? "Pre-DD Condition Inspection": ""}</span>
                                   
                                </div>
                                <div className="pl-4 input-group pb-3">
                                    <img className="pr-2" src={chevronsright} />
                                    <span className="span-design1">Completion Date : </span>
                                    <span className="pl-2 span-design2">{this.state.CompletionDate && moment(this.state.CompletionDate).format("DD/MM/YYYY")}</span>
                                </div>
                                <hr className="my-0 mx-4" style={{ border: '1px solid #E3E3E3' }} />
                                <div className="m-3" style={{ backgroundColor: '#003350' }}>
                                    <div className="p-2">
                                        <span style={{ color: '#FFFFFF' }}>Total Grade</span>
                                    </div>
                                    <div className="text-center" style={{ marginTop: '-30px' }}>
                                        <span className="grade-style">{this.state.TotalGrade && this.state.TotalGrade}</span>
                                    </div>
                                </div>
                                {(
                                    (this.state.ciiCompliance.EEXI !== "" &&
                                    this.state.ciiCompliance.EEXI !== null ) ||
                                    (this.state.ciiCompliance.EEDI !== "" &&
                                    this.state.ciiCompliance.EEDI !== null )||
                                    (this.state.ciiCompliance.AER !== "" &&
                                    this.state.ciiCompliance.AER !== null ) ||
                                    (this.state.ciiCompliance.CIIBand !== "" &&
                                    this.state.ciiCompliance.CIIBand !== null)
                                    )  ? (<>
                                <div className="m-3 cii-style">
                                    <div className="p-2 title">
                                        <span>EEXI & CII Compliance</span>
                                    </div>
                                     <div className="p-3 body row">
                                    <div className="text-center col-xl-5 col-lg-5 col-md-5 col-sm-5 col-12 pb-1">
                                        <span className="text-color">Required EEXI </span>
                                        <br/>
                                        <span className="value-color" style={{color:"#707175"}}>{this.state.ciiCompliance.EEXI ? this.state.ciiCompliance.EEXI:"No Data"}</span>
                                    </div>
                                    <div className="text-center col-xl-7 col-lg-7 col-md-7 col-sm-7 col-12 pl-0 pb-1">
                                        <span className="text-color">Attained EEDI/EEXI  </span><br/>
                                        <span className="value-color" style={{color:"#EB734E"}}>{this.state.ciiCompliance.EEDI ? this.state.ciiCompliance.EEDI :"No Data"}</span>
                                    </div>
                                    <div className="text-center col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-1" style={{borderBottom:"1px solid #28235B"}}></div>
                                    <div className="text-center col-xl-5 col-lg-5 col-md-5 col-sm-5 col-12 pt-2" >
                                        <span className="text-color">AER </span><br/>
                                        <span className="value-color" style={{color:"#ED1E18"}}>{this.state.ciiCompliance.AER ? this.state.ciiCompliance.AER: "No Data"}</span>
                                        <br/> <span className="text-color pt-1" style={{color:"#ED1E18"}}>{this.state.ciiCompliance.AER ? "in gCO2/DWT-nm":""}</span>
                                    </div>
                                    <div className="text-center col-xl-7 col-lg-7 col-md-7 col-sm-7 col-12 pt-2">
                                        <span className="text-color">CII Band  </span><br/>
                                        <span className="value-color" style={{color:"#ED1E18"}}>{this.state.ciiCompliance.CIIBand ? this.state.ciiCompliance.CIIBand: "No Data"}</span>
                                    </div>
                                    </div>
                                </div> </> ): null }
                            </div>
                        </div>
                        <div className={isMobile ? "col-12 px-0" : "col-9 col-sm9"}>
                            {this.state.ShipLogo != "" ?
                                <div className="mb-3 p-3" style={{ backgroundColor: "#F2F8FB" }}>
                                    <span className="text-center">
                                        <img src={this.state.ShipLogo} style={{ width: '100%', height: "600px" }}></img>
                                    </span>
                                </div> : <></>}
                            <div className="p-3 mb-3" style={{ backgroundColor: "#F2F8FB" }}>
                                <div className="row">
                                    <div className="col-12 p-3">
                                        <span style={{ fontSize: '18px', fontWeight: 'bold' }}>Vessel Particulars</span>
                                    </div>
                                </div>
                                <hr className="my-0" style={{ border: '1px solid #E3E3E3' }} />
                                <div className="row">
                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12 px-3 my-3" style={{ borderRight: '1px solid #E3E3E3' }}>
                                        <span className="span-design1">Management AS</span><br />
                                        <span className="span-design2">{this.state.ManagementAS && this.state.ManagementAS}</span>
                                    </div>
                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12 px-3 my-3" style={{ borderRight: '1px solid #E3E3E3' }}>
                                        <span className="span-design1">Breadth</span><br />
                                        <span className="span-design2">{this.state.Breadth && this.state.Breadth}</span>
                                    </div>
                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12 px-3 my-3" style={{ borderRight: '1px solid #E3E3E3' }}>
                                        <span className="span-design1">Previous Name</span><br />
                                        <span className="span-design2">{this.state.PreviousName && this.state.PreviousName}</span>
                                    </div>
                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12 px-3 my-3" style={{ borderRight: '1px solid #E3E3E3' }}>
                                        <span className="span-design1">Technical Manager</span><br />
                                        <span className="span-design2">{this.state.TechnicalManager && this.state.TechnicalManager}</span>
                                    </div>
                                </div>
                                <hr className="my-0" style={{ border: '1px solid #E3E3E3' }} />
                                <div className="row">
                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12 px-3 my-3" style={{ borderRight: '1px solid #E3E3E3' }}>
                                        <span className="span-design1">Depth</span><br />
                                        <span className="span-design2">{this.state.Depth && this.state.Depth}</span>
                                    </div>
                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12 px-3 my-3" style={{ borderRight: '1px solid #E3E3E3' }}>
                                        <span className="span-design1">Ship Builder</span><br />
                                        <span className="span-design2">{this.state.ShipBuilder && this.state.ShipBuilder}</span>
                                    </div>
                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12 px-3 my-3" style={{ borderRight: '1px solid #E3E3E3' }}>
                                        <span className="span-design1">Summer</span><br />
                                        <span className="span-design2">{this.state.Summer && this.state.Summer}</span>
                                    </div>
                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12 px-3 my-3" style={{ borderRight: '1px solid #E3E3E3' }}>
                                        <span className="span-design1">Port of Registry</span><br />
                                        <span className="span-design2">{this.state.PortOfRegistry && this.state.PortOfRegistry}</span>
                                    </div>
                                </div>
                                <hr className="my-0" style={{ border: '1px solid #E3E3E3' }} />
                                <div className="row">
                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12 px-3 my-3" style={{ borderRight: '1px solid #E3E3E3' }}>
                                        <span className="span-design1">Delivery Date</span><br />
                                        <span className="span-design2">{this.state.DeliveryDate && moment(this.state.DeliveryDate).format("DD/MM/YYYY")}</span>
                                    </div>
                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12 px-3 my-3" style={{ borderRight: '1px solid #E3E3E3' }}>
                                        <span className="span-design1">Call Sign</span><br />
                                        <span className="span-design2">{this.state.CallSign && this.state.CallSign}</span>
                                    </div>
                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12 px-3 my-3" style={{ borderRight: '1px solid #E3E3E3' }}>
                                        <span className="span-design1">Ship Type</span><br />
                                        <span className="span-design2">{this.state.ShipType == shipType.Bulker ? "Bulker" : this.state.ShipType == shipType.Tanker ? "Tanker" : this.state.ShipType == shipType.Container ? "Container" : ""}</span>
                                    </div>
                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12 px-3 my-3" style={{ borderRight: '1px solid #E3E3E3' }}>
                                        <span className="span-design1">Dead Weight</span><br />
                                        <span className="span-design2">{this.state.DeadWeight && this.state.DeadWeight}</span>
                                    </div>
                                </div>
                                <hr className="my-0" style={{ border: '1px solid #E3E3E3' }} />
                                <div className="row">
                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12 px-3 my-3" style={{ borderRight: '1px solid #E3E3E3' }}>
                                        <span className="span-design1">MMSI</span><br />
                                        <span className="span-design2">{this.state.Mmsi && this.state.Mmsi}</span>
                                    </div>
                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12 px-3 my-3" style={{ borderRight: '1px solid #E3E3E3' }}>
                                        <span className="span-design1">Flag</span><br />
                                        <span className="span-design2">{this.state.Flag && this.state.Flag}</span>
                                    </div>
                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12 px-3 my-3" style={{ borderRight: '1px solid #E3E3E3' }}>
                                        <span className="span-design1">Gross Tonnage</span><br />
                                        <span className="span-design2">{this.state.GrossTonnage && this.state.GrossTonnage}</span>
                                    </div>
                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12 px-3 my-3" style={{ borderRight: '1px solid #E3E3E3' }}>
                                        <span className="span-design1">TEU</span><br />
                                        <span className="span-design2">{this.state.Teu && this.state.Teu}</span>
                                    </div>
                                </div>
                                <hr className="my-0" style={{ border: '1px solid #E3E3E3' }} />
                                <div className="row">
                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12 px-3 my-3" style={{ borderRight: '1px solid #E3E3E3' }}>
                                        <span className="span-design1">Class</span><br />
                                        <span className="span-design2">{this.state.Class && this.state.Class}</span>
                                    </div>
                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12 px-3 my-3" style={{ borderRight: '1px solid #E3E3E3' }}>
                                        <span className="span-design1">Net Tonnage</span><br />
                                        <span className="span-design2">{this.state.NetTonnage && this.state.NetTonnage}</span>
                                    </div>
                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12 px-3 my-3" style={{ borderRight: '1px solid #E3E3E3' }}>
                                        <span className="span-design1">Light Weight</span><br />
                                        <span className="span-design2">{this.state.LightWeight && this.state.LightWeight}</span>
                                    </div>
                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12 px-3 my-3" style={{ borderRight: '1px solid #E3E3E3' }}>
                                        <span className="span-design1">Registered Owner</span><br />
                                        <span className="span-design2">{this.state.RegisteredOwner && this.state.RegisteredOwner}</span>
                                    </div>
                                </div>
                                <hr className="my-0" style={{ border: '1px solid #E3E3E3' }} />
                                <div className="row">
                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12 px-3 my-3" style={{ borderRight: '1px solid #E3E3E3' }}>
                                        <span className="span-design1">Length Overall</span><br />
                                        <span className="span-design2">{this.state.LengthOverall && this.state.LengthOverall}</span>
                                    </div>
                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12 px-3 my-3" style={{ borderRight: '1px solid #E3E3E3' }}>
                                        <span className="span-design1">Inspection Location</span><br />
                                        <span className="span-design2">{this.state.InspectionLocation && this.state.InspectionLocation}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="p-3 mb-3" style={{ backgroundColor: "#F2F8FB" }}>
                                <div className="row">
                                    <div className="col-12 p-3">
                                        <span style={{ fontSize: '18px', fontWeight: 'bold' }}>Inspection Summary</span>
                                    </div>
                                </div>
                                <hr className="my-0" style={{ border: '1px solid #E3E3E3' }} />
                                <div className="row">
                                    <div className="col-12 p-3">
                                        {/* <span>{this.state.InspectionSummary && this.state.InspectionSummary}</span> */}
                                        <div id="overview-font"
                                            dangerouslySetInnerHTML={{ __html: this.state.InspectionSummary }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="p-3 mb-3" style={{ backgroundColor: "#F2F8FB" }}>
                                <div className="row">
                                    <div className="col-12 p-3">
                                        <span style={{ fontSize: '18px', fontWeight: 'bold' }}>Grading Data</span>
                                    </div>
                                </div>
                                <hr className="my-0" style={{ border: '1px solid #E3E3E3' }} />
                                <div className="row">
                                    <div className="col-12 p-3">
                                        <div className="table-responsive" style={{ width: "100%" }}>
                                            <table
                                                id="Docstable"
                                                className="table table-borderless border-top border-bottom border-left border-right"
                                            >
                                                <thead>
                                                    <tr className="border-top section-color spandoc-thead">
                                                        <th className="border-right border-left" colSpan="12">
                                                            <span className="spandoc-thead">Vessel Condition</span>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.GradingData.map((y, index) => {
                                                        return (
                                                            <>
                                                                <tr className="border-top">
                                                                    <td
                                                                        width="40%"
                                                                        className="border-right align-middle"
                                                                        style={{ width: this.state.isMobile ? "28%" : "" }}
                                                                    >
                                                                        <span className="spandoc-thead">{y.title}</span>
                                                                    </td>
                                                                    {y.value == 0 ? <>
                                                                        <td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td>
                                                                    </> :
                                                                        (y.value > 0 && y.value <= 10) ? <>
                                                                            <td className="border-right active-color"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td>
                                                                        </> : (y.value >= 11 && y.value <= 20) ? <>
                                                                            <td className="border-right active-color"></td><td className="border-right active-color1"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td>
                                                                        </> : (y.value >= 21 && y.value <= 30) ? <>
                                                                            <td className="border-right active-color"></td><td className="border-right active-color1"></td><td className="border-right active-color2"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td>
                                                                        </> : (y.value >= 31 && y.value <= 40) ? <>
                                                                            <td className="border-right active-color"></td><td className="border-right active-color1"></td><td className="border-right active-color2"></td><td className="border-right active-color3"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td>
                                                                        </> : (y.value >= 41 && y.value <= 50) ? <>
                                                                            <td className="border-right active-color"></td><td className="border-right active-color1"></td><td className="border-right active-color2"></td><td className="border-right active-color3"></td><td className="border-right active-color4"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td>
                                                                        </> : (y.value >= 51 && y.value <= 60) ? <>
                                                                            <td className="border-right active-color"></td><td className="border-right active-color1"></td><td className="border-right active-color2"></td><td className="border-right active-color3"></td><td className="border-right active-color4"></td><td className="border-right active-color5"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td>
                                                                        </> : (y.value >= 61 && y.value <= 70) ? <>
                                                                            <td className="border-right active-color"></td><td className="border-right active-color1"></td><td className="border-right active-color2"></td><td className="border-right active-color3"></td><td className="border-right active-color4"></td><td className="border-right active-color5"></td><td className="border-right active-color6"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td>
                                                                        </> : (y.value >= 71 && y.value <= 80) ? <>
                                                                            <td className="border-right active-color"></td><td className="border-right active-color1"></td><td className="border-right active-color2"></td><td className="border-right active-color3"></td><td className="border-right active-color4"></td><td className="border-right active-color5"></td><td className="border-right active-color6"></td><td className="border-right active-color7"></td><td className="border-right"></td><td className="border-right"></td>
                                                                        </> : (y.value >= 81 && y.value <= 90) ? <>
                                                                            <td className="border-right active-color"></td><td className="border-right active-color1"></td><td className="border-right active-color2"></td><td className="border-right active-color3"></td><td className="border-right active-color4"></td><td className="border-right active-color5"></td><td className="border-right active-color6"></td><td className="border-right active-color7"></td><td className="border-right active-color8"></td><td className="border-right"></td>
                                                                        </> : (y.value >= 91 && y.value <= 100) ? <>
                                                                            <td className="border-right active-color"></td><td className="border-right active-color1"></td><td className="border-right active-color2"></td><td className="border-right active-color3"></td><td className="border-right active-color4"></td><td className="border-right active-color5"></td><td className="border-right active-color6"></td><td className="border-right active-color7"></td><td className="border-right active-color8"></td><td className="border-right active-color9"></td>
                                                                        </> :
                                                                            <><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td></>}
                                                                    <td className="text-center align-middle" style={{ fontWeight: 'bold', fontSize: '17px' }}>{y.value != undefined ? y.value : 0}</td>
                                                                </tr>
                                                            </>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 p-3">
                                        <div className="table-responsive" style={{ width: "100%" }}>
                                            <table
                                                id="Docstable"
                                                className="table table-borderless border-top border-bottom border-left border-right"
                                            >
                                                <thead>
                                                    <tr className="border-top section-color spandoc-thead">
                                                        <th className="border-right border-left" colSpan="12">
                                                            <span className="spandoc-thead">Vessel Management</span>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state?.GradingData1?.map((y, index) => {
                                                        return (
                                                            <>
                                                                <tr className="border-top">
                                                                    <td
                                                                        width="40%"
                                                                        className="border-right align-middle"
                                                                        style={{ width: this.state.isMobile ? "28%" : "" }}
                                                                    >
                                                                        <span className="spandoc-thead">{y.title}</span>
                                                                    </td>
                                                                    {y.value == 0 ? <>
                                                                        <td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td>
                                                                    </> :
                                                                        (y.value > 0 && y.value <= 10) ? <>
                                                                            <td className="border-right active-color"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td>
                                                                        </> : (y.value >= 11 && y.value <= 20) ? <>
                                                                            <td className="border-right active-color"></td><td className="border-right active-color1"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td>
                                                                        </> : (y.value >= 21 && y.value <= 30) ? <>
                                                                            <td className="border-right active-color"></td><td className="border-right active-color1"></td><td className="border-right active-color2"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td>
                                                                        </> : (y.value >= 31 && y.value <= 40) ? <>
                                                                            <td className="border-right active-color"></td><td className="border-right active-color1"></td><td className="border-right active-color2"></td><td className="border-right active-color3"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td>
                                                                        </> : (y.value >= 41 && y.value <= 50) ? <>
                                                                            <td className="border-right active-color"></td><td className="border-right active-color1"></td><td className="border-right active-color2"></td><td className="border-right active-color3"></td><td className="border-right active-color4"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td>
                                                                        </> : (y.value >= 51 && y.value <= 60) ? <>
                                                                            <td className="border-right active-color"></td><td className="border-right active-color1"></td><td className="border-right active-color2"></td><td className="border-right active-color3"></td><td className="border-right active-color4"></td><td className="border-right active-color5"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td>
                                                                        </> : (y.value >= 61 && y.value <= 70) ? <>
                                                                            <td className="border-right active-color"></td><td className="border-right active-color1"></td><td className="border-right active-color2"></td><td className="border-right active-color3"></td><td className="border-right active-color4"></td><td className="border-right active-color5"></td><td className="border-right active-color6"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td>
                                                                        </> : (y.value >= 71 && y.value <= 80) ? <>
                                                                            <td className="border-right active-color"></td><td className="border-right active-color1"></td><td className="border-right active-color2"></td><td className="border-right active-color3"></td><td className="border-right active-color4"></td><td className="border-right active-color5"></td><td className="border-right active-color6"></td><td className="border-right active-color7"></td><td className="border-right"></td><td className="border-right"></td>
                                                                        </> : (y.value >= 81 && y.value <= 90) ? <>
                                                                            <td className="border-right active-color"></td><td className="border-right active-color1"></td><td className="border-right active-color2"></td><td className="border-right active-color3"></td><td className="border-right active-color4"></td><td className="border-right active-color5"></td><td className="border-right active-color6"></td><td className="border-right active-color7"></td><td className="border-right active-color8"></td><td className="border-right"></td>
                                                                        </> : (y.value >= 91 && y.value <= 100) ? <>
                                                                            <td className="border-right active-color"></td><td className="border-right active-color1"></td><td className="border-right active-color2"></td><td className="border-right active-color3"></td><td className="border-right active-color4"></td><td className="border-right active-color5"></td><td className="border-right active-color6"></td><td className="border-right active-color7"></td><td className="border-right active-color8"></td><td className="border-right active-color9"></td>
                                                                        </> :
                                                                            <><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td><td className="border-right"></td></>}
                                                                    <td className="text-center align-middle" style={{ fontWeight: 'bold', fontSize: '17px' }}>{y.value != undefined ? y.value : 0}</td>
                                                                </tr>
                                                            </>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="p-3" style={{ backgroundColor: "#F2F8FB" }}>
                                <div className="row">
                                    <div className="col-12 p-3">
                                        <span style={{ fontSize: '18px', fontWeight: 'bold' }}>Key Notable Items</span>
                                    </div>
                                </div>
                                <hr className="my-0" style={{ border: '1px solid #E3E3E3' }} />
                                <div className={`table-responsive ${this.state.isMobile ? "" : "p-0"}`} style={{ width: "100%" }}>
                                    <table id="Docstable" className="table table-borderless border-top border-bottom border-left border-right">
                                        <thead>
                                            <tr className="table-active">
                                                <th className="border-top border-right text-center align-middle" width="4%" style={{ minWidth: '4%', maxWidth: '4%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Items</span></th>
                                                <th className="border-top border-right border-left text-center align-middle" width="32%" style={{ minWidth: '32%', maxWidth: '32%' }}><span className="spandoc-thead">Details</span></th>
                                                <th className="border-top border-right text-center align-middle" width="32%" style={{ minWidth: '32%', maxWidth: '32%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Due Date / Recommendation</span></th>
                                                <th className="border-top border-right text-center align-middle" width="32%" style={{ minWidth: '32%', maxWidth: '32%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Estimated Cost (USD)</span></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state?.dataList && this.state?.dataList?.map((i, index) => (
                                                <>
                                                    <tr>
                                                        <td className="border-right text-center align-middle">{index + 1}</td><td className="border-right">{i.Details}</td><td className="border-right">{i.Recommendation}</td><td className="border-right text-center align-middle">{i.EstimatedCost}</td>
                                                    </tr>
                                                </>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        projectStatus: state.projectReducer.projectStatus || [],
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Overview))
);
